(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-feature-chart-collapsible"] && !Shopify.designMode) return;
  try {
    
  var accordions = document.getElementsByClassName("custom-accordion");
for (let i = 0; i < accordions.length; i++) {
    accordions[i].addEventListener("click",function () {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    });
}

document.addEventListener("DOMContentLoaded", function() {
    // Get all elements with the class 'custom-accordion'
    var accordions = document.querySelectorAll('.custom-accordion');

    // Check if there are any elements with the class 'custom-accordion'
    if (accordions.length > 0) {
        // Get the first element
        var firstAccordion = accordions[0];
        
        // Add margin-top to the first element
        firstAccordion.style.marginTop = "50px";

        // Get the last element
        var lastAccordion = accordions[accordions.length - 1];
        
        // Add bottom border to the last element
        lastAccordion.style.borderBottom = "1px solid #ddd";

        // Add click event listener to the last element
        lastAccordion.addEventListener('click', function() {
            // Remove bottom border from the last accordion
            lastAccordion.style.borderBottom = "none";
            
            // Get all elements with the class 'custom-panel'
            var panels = document.querySelectorAll('.custom-panel');

            // Check if there are any elements with the class 'custom-panel'
            if (panels.length > 0) {
                // Get the last element
                var lastPanel = panels[panels.length - 1];

                // Add bottom border to the last panel
                lastPanel.style.borderBottom = "1px solid #ddd";
            }
        });
    }
});

  } catch(e) { console.error(e); }
})();
})();
